import axios from './http'
var qs = require('qs');


//工厂信息列表
export function httpEnterpriseList(page, pagesize, enterprise_name, registered_province, registered_city) {
    let data = {
        page, pagesize, enterprise_name, registered_province, registered_city
    }
    return axios({
        url: '/client/enterprise/enterprise/list',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//新增工厂信息
export function httpEnterpriseCreate(data) {
    return axios({
        url: '/client/enterprise/enterprise/create',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//查看工厂信息
export function httpEnterpriseEdit(template) {
    let data = {
        template
    }
    return axios({
        url: '/client/enterprise/enterprise/edit',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//修改工厂信息
export function httpEnterpriseUpdate(data) {
    return axios({
        url: '/client/enterprise/enterprise/update',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//删除工厂信息
export function httpEnterpriseDelete(template) {
    let data = {
        template
    }
    return axios({
        url: '/client/enterprise/enterprise/delete',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}